export default {
    'chatInput.connectionProblems': 'Problemer med internetforbindelsen.',
    'chatInput.reconnecting': 'Genopretter forbindelsen...',
    'chatInput.duplicateMessage': 'Du kan ikke sende den samme besked to gange i træk.',
    'chatInput.chatAttachment.uploadFileError': 'Der opstod en fejl da filen skulle sendes!',
    'chatInput.chatAttachment.fileSizeError': 'Det er ikke muligt at uploade filer større end 15 MB!',
    'chatInput.chatAttachment.maxFilesError': 'Det er ikke muligt at uploade mere end 5 filer på én gang',
    'chatInput.chatAttachment.sameFileError': 'Det er ikke muligt at uploade den samme fil igen!',
    'chatInput.autoComplete.edit': 'Rediger svar',
    'chatInput.autoComplete.send': 'Send intent',
    'chatInputField.chatInputPlaceholder': 'Spørg mig om noget...',
    'chatInputField.chatInputPlaceholderAgentMode': 'Skriv her til brugeren...',
    'chatInputField.chatInputPlaceholderFileUploadMode': 'Skriv, hvad der skal gøres med indholdet af filen.',
    'chatInputField.suggestionInputPlaceholder': 'Tryk på en af valgmulighederne...',
    'speechBubble.dateTime.today' : 'I dag',
    'speechBubble.dateTime.at' : 'kl.',
    'infoPage.privacyPolicyLinkText': 'Privatlivspolitik',
    'infoPage.goBackButtonText': 'Tilbage',
    'chatInput..title.send': 'Send besked',
    'topBar.title.help': 'Info',
    'topBar.title.mini': 'Minimere/Maksimere',
    'topBar.title.close': 'Luk chat',
}
